import React from "react";
import { IChildren } from "@components/interfaces/IChildren";

const NoLayout = ({ children }: IChildren) => {
  return <>{children}</>;
};

export default NoLayout;
